import React from 'react';
import { useReducer } from 'react';
import CartContext from './CartContext'


const defaultCartState ={
    items: [],
    totalAmountBTC: 0,
    totalAmountETH:0
};

const cartReducer =(state, action) =>{
    if (action.type === 'ADD'){
        const updatedTotalAmountBTC = state.totalAmountBTC + action.item.priceBTC * action.item.amount;
        const updatedTotalAmountETH = state.totalAmountETH + action.item.priceETH * action.item.amount;

        const existingItemIndex = state.items.findIndex((item) => item.id === action.item.id);
        const existingItem = state.items[existingItemIndex];

        let updatedItems;

        if(existingItem){
            const updatedItem= {
                ...existingItem,
                amount: existingItem.amount +action.item.amount
            };
            updatedItems= [...state.items];
            updatedItems[existingItemIndex]=updatedItem;
        } else{
            updatedItems=state.items.concat(action.item); 
        }

        return {
            items: updatedItems,
            totalAmountBTC: updatedTotalAmountBTC,
            totalAmountETH: updatedTotalAmountETH,
        }
    }

    if(action.type === 'REMOVE'){
        const existingItemIndex=state.items.findIndex((item) => item.id===action.id);
        const existingItem = state.items[existingItemIndex];
        const updatedTotalAmountBTC= state.totalAmountBTC - existingItem.priceBTC * existingItem.amount;
        const updatedTotalAmountETH= state.totalAmountETH - existingItem.priceETH * existingItem.amount;

        let updatedItems= state.items.filter(item => item.id !== action.id);

        return{
            items: updatedItems,
            totalAmountBTC: updatedTotalAmountBTC,
            totalAmountETH: updatedTotalAmountETH
        };
    }


    return defaultCartState;
}



const CartProvider = (props) => {

    const [cartState, dispatchCartAction] = useReducer(cartReducer,defaultCartState);

    const addItemHandler =(item)=>{
        dispatchCartAction({
            type: 'ADD',
            item: item
        });
    };
    const removeItemHandler= (id)=>{
        dispatchCartAction({
            type: 'REMOVE',
            id: id
        });
    };
    const cartContext ={
        items:cartState.items,
        totalAmountBTC: cartState.totalAmountBTC,
        totalAmountETH: cartState.totalAmountETH,
        addItem: addItemHandler,
        removeItem:removeItemHandler,
    }


    return (
        <CartContext.Provider value={cartContext}>
            {props.children}
        </CartContext.Provider>
    )
}

export default CartProvider
